<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created() {
    document.title = "普康 智慧病案协作平台";
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  min-width: 1280PX;
}
html,
body {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
}
</style>
